import type { AlertLevel } from './HeaderAlerts.types';

import { NoticeRibbonType } from '../../../common/components/atoms/NoticeRibbon';
import { AlertLevels } from './HeaderAlerts.types';

export const isAlertLevelSupported = (num: number): num is AlertLevel => {
    return AlertLevels.includes(num as AlertLevel);
};

export const getNoticeTypeForAlertLevel = (level?: AlertLevel) => {
    switch (level) {
        case 4:
            return NoticeRibbonType.success;
        case 3:
            return NoticeRibbonType.warning;
        case 2:
            return NoticeRibbonType.error;
        case 1:
            return NoticeRibbonType.critical;
        default: {
            // eslint-disable-next-line no-console
            console.error('Unsupported alert level. Using Level1 as fallback');
            return NoticeRibbonType.critical;
        }
    }
};
